import { useLocation, useParams } from 'react-router-dom';
import { usePageViewTracking } from './usePageViewTracking';
import { getTrackingConfig, extractChildPageId } from '../config/trackingConfig';

export const useAutoPageTracking = () => {

    const location = useLocation();
    const params = useParams();

    // Get tracking config for current route
    const config = getTrackingConfig(location.pathname);

    // Extract IDs
    const masterPageId = (config?.trackingEnabled) ? config.masterPageId : 0;
    const childPageId = extractChildPageId(config, location, params);

    // Track page view
    // const { pageViewCount } = masterPageId > 0  ? usePageViewTracking(masterPageId, childPageId)  : { pageViewCount: 0 };

    const { pageViewCount } = usePageViewTracking(
        masterPageId > 0 ? masterPageId : null,
        childPageId
    );

    return {
        pageViewCount: masterPageId > 0 ? pageViewCount : 0,
        routeName: config?.name || 'Unknown Page',
        isTracked: config?.trackingEnabled || false,
        masterPageId,
        childPageId
    };
};